import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PlusLogo from '../../../../Assets/Images/plus-square.png';
import { Articles, Books } from './_component';

function Home() {
  const [activeTab, setActiveTab] = useState('book');

  const navigate = useNavigate();

  useEffect(() => {
    const url = new URL(window.location);
    let tab = url.searchParams.get('tab');

    if (['book', 'articles'].includes(tab)) tab = 'book';
    setActiveTab(tab);
  }, []);

  return (
    <div className="home my-12 px-8 innerDashboard">
      {/* <Logo /> */}
      <div className="header md:flex-row flex-col md:justify-between justify-center  flex ">
        <div className="flex align-middle items-center mb-[56px] ">
          <h2 className="text-[32px] font-extrabold  ">{activeTab === 'book' ? 'Books' : 'Articles'}</h2>
          <div className="flex p-1 bookArticeASwitch h-[48px] rounded-lg ml-8">
            <div
              className={`flex align-middle justify-center align text-center items-center h-10 rounded-lg w-24 leading-[10px] cursor-pointer font-semibold ${
                activeTab === 'book' ? 'active' : ''
              }`}
              onClick={() => {
                setActiveTab('book');
                navigate('?tab=book');
              }}>
              Books
            </div>
            <div
              className={`flex align-middle justify-center align text-center items-center h-10 rounded-lg w-24 leading-[10px] cursor-pointer font-semibold ${
                activeTab === 'articles' ? 'active' : ''
              }`}
              onClick={() => {
                setActiveTab('articles');
                navigate('?tab=articles');
              }}>
              Articles
            </div>
          </div>
        </div>
        {activeTab === 'book' ? (
          <Link to="/book/add-book">
            <button className="text-base flex justify-center items-center bg-gray-100  h-[48px]  w-[218px] rounded-xl   font-[Poppins-Bold] transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105">
              <img src={PlusLogo} className="mr-2" />
              New Book
            </button>
          </Link>
        ) : (
          <Link to="/article/add-article">
            <button className="text-base flex justify-center items-center bg-gray-100  h-[48px]  w-[218px] rounded-xl   font-[Poppins-Bold] transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105">
              <img src={PlusLogo} className="mr-2" />
              New Article
            </button>
          </Link>
        )}
      </div>
      {activeTab === 'book' ? <Books /> : <Articles />}
    </div>
  );
}

export default Home;
